import { styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const Content = styled('div')(() => ({
  padding: '1.5rem 1rem',
 
  [theme.breakpoints.up('md')]: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
}));

export const FlexContainer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  gap: '2rem',
  height: '100%',
  flexDirection: 'column',
}));
